"use strict";
exports.__esModule = true;
// (C) 2020 GoodData Corporation
var common_1 = require("./common");
var EmbeddedKpiDashboard;
(function (EmbeddedKpiDashboard) {
    /**
     * All KD command Types.
     */
    var GdcKdCommandType;
    (function (GdcKdCommandType) {
        /**
         * The command save a dashboard.
         */
        GdcKdCommandType["Save"] = "saveDashboard";
        /**
         * The command cancel editing dashboard.
         */
        GdcKdCommandType["CancelEdit"] = "cancelEdit";
        /**
         * The command delete existed dashboard.
         */
        GdcKdCommandType["Delete"] = "deleteDashboard";
        /**
         * The command edit a dashboard.
         */
        GdcKdCommandType["SwitchToEdit"] = "switchToEdit";
        /**
         * The command set drillable items.
         */
        GdcKdCommandType["DrillableItems"] = "drillableItems";
        /**
         * The command set size of dashboard.
         */
        GdcKdCommandType["SetSize"] = "setSize";
        /**
         * The command add widget to dashboard.
         */
        GdcKdCommandType["AddWidget"] = "addWidget";
        /**
         * The command add filter to dashboard.
         */
        GdcKdCommandType["AddFilter"] = "addFilter";
        /**
         * The command export a dashboard.
         */
        GdcKdCommandType["ExportToPdf"] = "exportToPdf";
        /**
         * The command to add or update filter context
         */
        GdcKdCommandType["SetFilterContext"] = "setFilterContext";
        /**
         * The command to remove filter item from current filter context
         */
        GdcKdCommandType["RemoveFilterContext"] = "removeFilterContext";
        /**
         * The command to duplicate a KPI Dashboard
         */
        GdcKdCommandType["SaveAsDashboard"] = "saveAsDashboard";
    })(GdcKdCommandType = EmbeddedKpiDashboard.GdcKdCommandType || (EmbeddedKpiDashboard.GdcKdCommandType = {}));
    /**
     * All KD event types.
     */
    var GdcKdEventType;
    (function (GdcKdEventType) {
        /**
         * Type represent that the dashboard listening for drilling event.
         */
        GdcKdEventType["ListeningForDrillableItems"] = "listeningForDrillableItems";
        /**
         * Type represent that the embedded content starts loading.
         */
        GdcKdEventType["LoadingStarted"] = "loadingStarted";
        /**
         * Type represent that The user does not have permissions to view or edit the content.
         */
        GdcKdEventType["NoPermissions"] = "noPermissions";
        /**
         * Type represent that an operation increasing the height of the hosting iframe is performed.
         */
        GdcKdEventType["Resized"] = "resized";
        /**
         * Type represent that the dashboard has been created and saved.
         */
        GdcKdEventType["DashboardCreated"] = "dashboardCreated";
        /**
         * Type represent that the content is fully loaded,
         * and the user has permissions to access the dashboard.
         */
        GdcKdEventType["DashboardLoaded"] = "loaded";
        /**
         * Type represent that the existing dashboard has been updated.
         */
        GdcKdEventType["DashboardUpdated"] = "dashboardUpdated";
        /**
         * Type represent that the dashboard is saved.
         *
         */
        GdcKdEventType["DashboardSaved"] = "dashboardSaved";
        /**
         * Type represent that the dashboard is deleted.
         *
         */
        GdcKdEventType["DashboardDeleted"] = "dashboardDeleted";
        /**
         * Type represent that the user cancels the creation of the dashboard.
         */
        GdcKdEventType["DashboardCreationCanceled"] = "dashboardCreationCanceled";
        /**
         * Type represent that the dashboard is switched to edit mode.
         */
        GdcKdEventType["SwitchedToEdit"] = "switchedToEdit";
        /**
         * Type represent that the dashboard is switched to view mode.
         */
        GdcKdEventType["SwitchedToView"] = "switchedToView";
        /**
         * Type represent that the platform is down.
         */
        GdcKdEventType["Platform"] = "platform";
        /**
         * Type represent that the widget is added to dashboard.
         *
         */
        GdcKdEventType["WidgetAdded"] = "widgetAdded";
        /**
         * Type represent that the filter is added to dashboard.
         *
         */
        GdcKdEventType["FilterAdded"] = "filterAdded";
        /**
         * Type represent that the export action is finished.
         */
        GdcKdEventType["ExportedToPdf"] = "exportedToPdf";
        /**
         * Type represent that the drill performed
         */
        GdcKdEventType["Drill"] = "drill";
        /**
         * Type represent that the filter context is changed
         */
        GdcKdEventType["FilterContextChanged"] = "filterContextChanged";
        /**
         * Type represent that the set filter context action is finished
         */
        GdcKdEventType["SetFilterContextFinished"] = "setFilterContextFinished";
        /**
         * Type represent that the remove filter context action is finished
         */
        GdcKdEventType["RemoveFilterContextFinished"] = "removeFilterContextFinished";
        /**
         * Type that represents started drill to URL. The event does not contain an URL. The event can be used as
         * notification to display a loading indicator as the URL resolving takes some time. The URL is sent in
         * DrillToUrlResolved event which is posted after the URL is resolved. The event also contains an ID that can
         * be matched with ID in subsequently posted DrillToUrlResolved event.
         */
        GdcKdEventType["DrillToUrlStarted"] = "drillToUrlStarted";
        /**
         * Type that represents resolved drill to URL. The event is sent after DrillToUrlStarted event was posted and
         * it contains the resolved URL. The event also contains an ID which can be matched with ID from
         * DrillToUrlStarted event.
         */
        GdcKdEventType["DrillToUrlResolved"] = "drillToUrlResolved";
    })(GdcKdEventType = EmbeddedKpiDashboard.GdcKdEventType || (EmbeddedKpiDashboard.GdcKdEventType = {}));
    /**
     * Type-guard checking whether object is an instance of {@link SaveDashboardCommandData}.
     *
     * @param obj - object to test
     */
    function isSaveDashboardCommandData(obj) {
        return common_1.getEventType(obj) === GdcKdCommandType.Save;
    }
    EmbeddedKpiDashboard.isSaveDashboardCommandData = isSaveDashboardCommandData;
    /**
     * Type-guard checking whether object is an instance of {@link SaveAsDashboardCommandData}.
     *
     * @param obj - object to test
     */
    function isSaveAsDashboardCommandData(obj) {
        return common_1.getEventType(obj) === GdcKdCommandType.SaveAsDashboard;
    }
    EmbeddedKpiDashboard.isSaveAsDashboardCommandData = isSaveAsDashboardCommandData;
    /**
     * Type-guard checking whether object is an instance of {@link CancelEditData}.
     *
     * @param obj - object to test
     */
    function isCancelEditCommandData(obj) {
        return common_1.getEventType(obj) === GdcKdCommandType.CancelEdit;
    }
    EmbeddedKpiDashboard.isCancelEditCommandData = isCancelEditCommandData;
    /**
     * Type-guard checking whether object is an instance of {@link SwitchToEditCommandData}.
     *
     * @param obj - object to test
     */
    function isSwitchToEditCommandData(obj) {
        return common_1.getEventType(obj) === GdcKdCommandType.SwitchToEdit;
    }
    EmbeddedKpiDashboard.isSwitchToEditCommandData = isSwitchToEditCommandData;
    /**
     * Type-guard checking whether object is an instance of {@link DrillableItemsCommandData}.
     *
     * @param obj - object to test
     */
    function isDrillableItemsCommandData(obj) {
        return common_1.getEventType(obj) === GdcKdCommandType.DrillableItems;
    }
    EmbeddedKpiDashboard.isDrillableItemsCommandData = isDrillableItemsCommandData;
    /**
     * Type-guard checking whether object is an instance of {@link SetSizeCommandData}.
     *
     * @param obj - object to test
     */
    function isSetSizeCommandData(obj) {
        return common_1.getEventType(obj) === GdcKdCommandType.SetSize;
    }
    EmbeddedKpiDashboard.isSetSizeCommandData = isSetSizeCommandData;
    /**
     * Type-guard checking whether an object is an instance of {@link SetFilterContextCommand}
     *
     * @param obj - object to test
     */
    function isSetFilterContextCommandData(obj) {
        return common_1.getEventType(obj) === GdcKdCommandType.SetFilterContext;
    }
    EmbeddedKpiDashboard.isSetFilterContextCommandData = isSetFilterContextCommandData;
    /**
     * Type-guard checking whether an object is an instance of {@link RemoveFilterContextCommand}
     *
     * @param obj - object to test
     */
    function isRemoveFilterContextCommandData(obj) {
        return common_1.getEventType(obj) === GdcKdCommandType.RemoveFilterContext;
    }
    EmbeddedKpiDashboard.isRemoveFilterContextCommandData = isRemoveFilterContextCommandData;
    /**
     * Type-guard checking whether object is an instance of {@link IdentifierInsightRef}.
     *
     * @param obj - object to test
     */
    function isIdentifierInsight(obj) {
        return obj.identifier;
    }
    EmbeddedKpiDashboard.isIdentifierInsight = isIdentifierInsight;
    /**
     * Type-guard checking whether object is an instance of {@link UriInsightRef}.
     *
     * @param obj - object to test
     */
    function isUriInsight(obj) {
        return obj.uri;
    }
    EmbeddedKpiDashboard.isUriInsight = isUriInsight;
    /**
     * Type-guard checking whether object is an instance of {@link AddWidgetCommandData}.
     *
     * @param obj - object to test
     */
    function isAddWidgetCommandData(obj) {
        return common_1.getEventType(obj) === GdcKdCommandType.AddWidget;
    }
    EmbeddedKpiDashboard.isAddWidgetCommandData = isAddWidgetCommandData;
    /**
     * Type-guard checking whether object is an instance of {@link AddFilterCommandData}.
     *
     * @param obj - object to test
     */
    function isAddFilterCommandData(obj) {
        return common_1.getEventType(obj) === GdcKdCommandType.AddFilter;
    }
    EmbeddedKpiDashboard.isAddFilterCommandData = isAddFilterCommandData;
    /**
     * Type-guard checking whether object is an instance of {@link ExportToPdfCommandData}.
     *
     * @param obj - object to test
     */
    function isExportToPdfCommandData(obj) {
        return common_1.getEventType(obj) === GdcKdCommandType.ExportToPdf;
    }
    EmbeddedKpiDashboard.isExportToPdfCommandData = isExportToPdfCommandData;
})(EmbeddedKpiDashboard = exports.EmbeddedKpiDashboard || (exports.EmbeddedKpiDashboard = {}));
//# sourceMappingURL=kd.js.map